import { fetchActionSources } from 'frontcore/utils/communications/actions'
import { PROMISE_STATUS } from 'frontcore/constants/promises'

const stateObj = {
  actionSources: [],
  actionSourcesPromise: null,
  sourceActionsStatus: PROMISE_STATUS.notStarted,
}

const getters = {
  getActionSources (state) {
    return state.actionSources
  },
  getActionSourceById: (state) => (id) => {
    return state.actionSources.find(source => source.id === id)
  },
  actionSourcesAreLoaded (state) {
    return state.sourceActionsStatus === PROMISE_STATUS.complete
  },
}

const mutations = {
  setActionSources (state, value) {
    state.actionSources = value
  },
  setActionPriorities (state, value) {
    state.actionPriorities = value
  },
  setSourceActionsStatus (state, status) {
    state.sourceActionsStatus = status
  },
}

const actions = {
  fetchSourceActions ({ commit, state }, force = false) {
    if (state.sourceActionsStatus !== PROMISE_STATUS.complete || force) {
      state.actionSourcesPromise = fetchActionSources(false)
      commit('setSourceActionsStatus', PROMISE_STATUS.pending)
    }
    return !state.actionSourcesPromise ? state.actionSources : state.actionSourcesPromise.then((sourcesList) => {
      const sources = sourcesList.map((source) => {
        return {
          id: source.id,
          name: source.name,
          active: source.active,
        }
      })
      commit('setActionSources', sources)
      commit('setSourceActionsStatus', PROMISE_STATUS.complete)
      return sources
    }).catch(e => {
      throw e
    })
      .finally(() => {
        state.actionSourcesPromise = null
      })
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
